import { motion } from "framer-motion";
import BgOrnaments from "@/components/vu/BgOrnaments";


// Mini live UI previews rendered inside each card
const WebsitePreview = () => (
    <div className="relative w-full h-full rounded-xl bg-gradient-to-br from-[#0E1F16] to-[#1A2D22] border border-[#1F3A2B] overflow-hidden p-3">
        <div className="flex items-center gap-1.5 mb-2.5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#DFFF3D]" />
            <span className="w-1.5 h-1.5 rounded-full bg-[#EAFF6B]" />
            <span className="w-1.5 h-1.5 rounded-full bg-white/10" />
            <span className="ml-auto mono text-[7.5px] text-[#7A9088]">vusolutions.com</span>
        </div>
        <div className="space-y-1.5">
            <div className="h-1.5 rounded-full bg-[#DFFF3D]/70 w-3/5" />
            <div className="h-1.5 rounded-full bg-white/20 w-4/5" />
            <div className="grid grid-cols-3 gap-1.5 mt-2">
                <div className="aspect-square rounded bg-white/5" />
                <div className="aspect-square rounded bg-[#DFFF3D]/30" />
                <div className="aspect-square rounded bg-white/5" />
            </div>
            <div className="h-2.5 rounded-full bg-[#DFFF3D] w-1/3 mt-2" />
        </div>
    </div>
);

const MapPreview = () => (
    <div className="relative w-full h-full rounded-xl bg-gradient-to-br from-[#1A2D22] to-[#0E1F16] border border-[#1F3A2B] overflow-hidden p-3">
        {/* Fake map roads */}
        <svg viewBox="0 0 120 100" className="absolute inset-0 w-full h-full opacity-40">
            <path d="M0 40 Q30 20 60 40 T120 30" stroke="#2A4A38" strokeWidth="1.5" fill="none" />
            <path d="M20 0 Q30 40 50 60 T90 100" stroke="#2A4A38" strokeWidth="1.5" fill="none" />
            <path d="M80 0 L80 100" stroke="#2A4A38" strokeWidth="1" fill="none" />
        </svg>
        <div className="relative flex flex-col h-full justify-between">
            <div className="flex items-center gap-1.5">
                <i className="fa-solid fa-location-dot text-[#DFFF3D] text-[16px]" style={{ filter: "drop-shadow(0 2px 4px rgba(217,119,87,0.5))" }} />
                <div className="bg-[#152A20]/90 backdrop-blur px-2 py-1 rounded-md border border-[#1F3A2B]">
                    <div className="text-[9px] font-semibold text-[#F5F0E8]">Your Business</div>
                    <div className="flex items-center gap-1 text-[8px] text-[#DFFF3D]">
                        <i className="fa-solid fa-star" /><i className="fa-solid fa-star" /><i className="fa-solid fa-star" /><i className="fa-solid fa-star" /><i className="fa-solid fa-star" />
                        <span className="text-[#7A9088]">5.0</span>
                    </div>
                </div>
            </div>
            <div className="bg-[#152A20]/80 backdrop-blur rounded-md p-1.5 border border-[#1F3A2B]">
                <div className="flex items-center justify-between text-[8.5px] mb-1">
                    <span className="text-[#7A9088]">Map Pack Ranking</span>
                    <span className="mono text-[#DFFF3D] font-semibold">#1</span>
                </div>
                <div className="h-1 rounded-full bg-[#1F3A2B] overflow-hidden">
                    <div className="vu-bar h-full bg-[#DFFF3D] rounded-full" style={{ "--w": 0.92 }} />
                </div>
            </div>
        </div>
    </div>
);

const AdsPreview = () => (
    <div className="relative w-full h-full rounded-xl bg-gradient-to-br from-[#0E1F16] to-[#1A2D22] border border-[#1F3A2B] overflow-hidden p-3 flex flex-col">
        <div className="flex justify-between items-center mb-2">
            <span className="mono text-[8px] text-[#7A9088]">ROAS · Q1</span>
            <span className="mono text-[8px] text-[#DFFF3D] font-semibold">↑ +142%</span>
        </div>
        <div className="flex-1 min-h-[60px] flex items-end justify-between gap-1">
            {[0.4, 0.55, 0.35, 0.7, 0.5, 0.85, 0.95].map((h, i) => (
                <div key={i} className="flex-1 flex flex-col justify-end h-full">
                    <div className="vu-bar-y w-full rounded-t bg-gradient-to-t from-[#B8D622] to-[#DFFF3D]" style={{ height: `${h * 100}%`, animationDelay: `${i * 0.08}s` }} />
                </div>
            ))}
        </div>
        <div className="mt-2 grid grid-cols-2 gap-1.5">
            <div className="bg-[#152A20]/80 border border-[#1F3A2B] rounded p-1.5">
                <div className="mono text-[7px] text-[#7A9088]">CTR</div>
                <div className="font-display text-[11px] text-[#F5F0E8]">6.8%</div>
            </div>
            <div className="bg-[#152A20]/80 border border-[#1F3A2B] rounded p-1.5">
                <div className="mono text-[7px] text-[#7A9088]">CPA</div>
                <div className="font-display text-[11px] text-[#F5F0E8]">$12</div>
            </div>
        </div>
    </div>
);

const InboxPreview = () => (
    <div className="relative w-full h-full rounded-xl bg-gradient-to-br from-[#1A2D22] to-[#0E1F16] border border-[#1F3A2B] overflow-hidden p-3 flex flex-col">
        <div className="flex justify-between items-center text-[7.5px] mono text-[#7A9088] mb-2">
            <span>INBOX · TODAY</span>
            <span>3 NEW</span>
        </div>
        <div className="flex-1 flex flex-col justify-center gap-1.5 min-h-0">
            {[
                { s: "Bloom Dental", p: "Your appointment is confirmed →", u: true, i: "fa-envelope" },
                { s: "Halcyon Coffee", p: "New drop — 15% for regulars", u: true, i: "fa-comment-sms" },
                { s: "Marlow Studio", p: "Thanks for stopping by ✦", u: false, i: "fa-envelope-open" },
            ].map((m, i) => (
                <div key={i} className={`flex items-start gap-2 p-1.5 rounded-md border ${m.u ? "bg-[#152A20] border-[#DFFF3D]/25" : "bg-[#152A20]/60 border-[#1F3A2B]"}`}>
                    <div className="w-5 h-5 rounded-md bg-gradient-to-br from-[#DFFF3D] to-[#B8D622] flex items-center justify-center shrink-0">
                        <i className={`fa-solid ${m.i} text-[#0E1F16] text-[8px]`} />
                    </div>
                    <div className="min-w-0 flex-1">
                        <div className="text-[8.5px] font-semibold text-[#F5F0E8] truncate">{m.s}</div>
                        <div className="text-[8px] text-[#7A9088] truncate">{m.p}</div>
                    </div>
                    {m.u && <div className="w-1 h-1 rounded-full bg-[#DFFF3D] shrink-0 mt-1" />}
                </div>
            ))}
        </div>
        <div className="flex justify-between text-[7.5px] mono text-[#7A9088] pt-2 mt-2 border-t border-[#1F3A2B]">
            <span>Open · 42%</span>
            <span className="text-[#DFFF3D]">Click · 8.4%</span>
        </div>
    </div>
);

// AI Voice preview — live call transcript + waveform
const VoicePreview = () => (
    <div className="relative w-full h-full rounded-xl bg-gradient-to-br from-[#0E1F16] to-[#1A2D22] border border-[#1F3A2B] overflow-hidden p-3">
        <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-1.5">
                <span className="relative flex w-1.5 h-1.5">
                    <span className="absolute inline-flex h-full w-full rounded-full bg-[#DFFF3D] opacity-70 vu-live-dot" />
                    <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#DFFF3D]" />
                </span>
                <span className="mono text-[7.5px] text-[#DFFF3D] font-semibold">LIVE · AI AGENT</span>
            </div>
            <span className="mono text-[7.5px] text-[#7A9088]">00:47</span>
        </div>
        {/* waveform */}
        <div className="flex items-center justify-center gap-[2px] h-[26px] mb-2 bg-[#152A20]/50 rounded-md border border-[#1F3A2B] px-2">
            {[0.3, 0.6, 0.9, 0.5, 0.8, 0.4, 0.95, 0.35, 0.7, 0.55, 0.85, 0.4, 0.6, 0.9, 0.5, 0.75, 0.45, 0.8, 0.3, 0.6].map((h, i) => (
                <span key={i} className="w-[2px] rounded-full bg-gradient-to-t from-[#B8D622] to-[#DFFF3D] vu-bar-y" style={{ height: `${h * 100}%`, animationDelay: `${i * 0.05}s` }} />
            ))}
        </div>
        {/* transcript */}
        <div className="space-y-1">
            <div className="flex items-start gap-1.5">
                <span className="mono text-[7px] text-[#7A9088] pt-0.5">AI</span>
                <div className="flex-1 bg-[#152A20] border border-[#DFFF3D]/25 rounded-md px-1.5 py-1 text-[7.5px] text-[#F5F0E8] leading-tight">Booking Tues 3pm for a cleaning — confirm?</div>
            </div>
            <div className="flex items-start gap-1.5 flex-row-reverse">
                <span className="mono text-[7px] text-[#DFFF3D] pt-0.5">YOU</span>
                <div className="flex-1 bg-[#152A20]/60 border border-[#1F3A2B] rounded-md px-1.5 py-1 text-[7.5px] text-[#A6BDB0] leading-tight text-right">Yes please.</div>
            </div>
        </div>
        <div className="mt-2 flex justify-between text-[7.5px] mono text-[#7A9088]">
            <span>Sentiment · positive</span>
            <span className="text-[#DFFF3D]">Booked ✓</span>
        </div>
    </div>
);

const cards = [
    { icon: "fa-code", num: "S/01", title: "Website Design & Development", desc: "Fast, mobile-first websites built to turn visitors into calls.", tags: ["FAST-LOADING", "MOBILE-FIRST", "CONVERSION"], Preview: WebsitePreview, span: "md:col-span-3" },
    { icon: "fa-brands fa-google", num: "S/02", title: "Google Business Profile & Local SEO", desc: "Own the map pack and get found where customers search.", tags: ["MAP RANKINGS", "REVIEWS", "LOCAL"], Preview: MapPreview, span: "md:col-span-3" },
    { icon: "fa-bullseye", num: "S/03", title: "Google & Meta Ads", desc: "Full-funnel paid campaigns engineered for ROAS, not vanity clicks.", tags: ["PAID SEARCH", "SOCIAL", "ROI"], Preview: AdsPreview, span: "md:col-span-3" },
    { icon: "fa-envelope-open-text", num: "S/04", title: "Email & SMS Campaigns", desc: "Lifecycle flows that recover carts and bring customers back.", tags: ["AUTOMATIONS", "SMS", "RETENTION"], Preview: InboxPreview, span: "md:col-span-3" },
    { icon: "fa-phone-volume", num: "S/05", title: "AI Voice Agent — 24/7", desc: "A natural-sounding AI phone agent that answers, qualifies, and books every lead — even at 2am.", tags: ["24/7 ANSWER", "BOOKING", "TRANSCRIPTS", "MULTI-LANGUAGE"], Preview: VoicePreview, span: "md:col-span-6", partner: "Powered by Orbit Force AI", featured: true },
];

export default function Services() {
    return (
        <section id="services" data-testid="services-section" className="relative py-[110px] md:py-[130px] border-t border-[#1F3A2B] overflow-hidden">
            <BgOrnaments variant="dots" />
            <div className="max-w-[1240px] mx-auto px-8">
                <div className="text-center max-w-[640px] mx-auto mb-16">
                    <div className="inline-flex items-center gap-2 px-3.5 py-1.5 border border-[#2A4A38] bg-[#152A20]/70 backdrop-blur rounded-full text-[11.5px] text-[#A6BDB0] mb-5">
                        <span className="w-[7px] h-[7px] rounded-full bg-[#DFFF3D]" /> Our Services
                    </div>
                    <h2 className="font-display text-[#F5F0E8] tracking-tight leading-[1.02]" style={{ fontSize: "clamp(2.4rem, 4.4vw, 3.4rem)" }}>
                        Every channel that brings customers,<br />
                        <span className="italic-serif text-[#DFFF3D]">handled in-house.</span>
                    </h2>
                    <p className="mt-5 text-[15.5px] text-[#A6BDB0]">From the first line of code to your fifth quarter of paid growth — under one roof, on one retainer.</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-6 gap-6">
                    {cards.map((c, i) => {
                        const P = c.Preview;
                        return (
                            <motion.a
                                href="#contact"
                                key={c.title}
                                data-testid={`service-card-${i}`}
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-10%" }}
                                transition={{ duration: 0.6, delay: i * 0.08 }}
                                whileHover={{ y: -6 }}
                                className={`group relative bg-[#152A20] rounded-[28px] p-6 md:p-7 overflow-hidden card-shadow card-shadow-hover grad-border tilt-lift will-change-transform ${c.span} ${c.featured ? "border-[#DFFF3D]/40 warm-glow" : ""}`}
                            >
                                <div className="card-grain absolute inset-0" />
                                <div className={`relative gap-6 items-stretch min-h-[240px] grid ${c.span === "md:col-span-6" ? "md:grid-cols-[1fr_1.3fr]" : "md:grid-cols-[1fr_1.1fr]"}`}>
                                    <div className="flex flex-col justify-between">
                                        <div className="flex items-center justify-between">
                                            <span className="mono text-[10px] text-[#7A9088]">{c.num} · SERVICE</span>
                                            <div className="w-9 h-9 rounded-full border border-[#DFFF3D]/40 bg-[#DFFF3D]/10 flex items-center justify-center text-[#DFFF3D] group-hover:bg-[#DFFF3D] group-hover:text-[#0E1F16] group-hover:border-[#DFFF3D] transition-all shrink-0">
                                                <i className="fa-solid fa-arrow-right text-[11px]" />
                                            </div>
                                        </div>
                                        <div className="mt-6 md:mt-8">
                                            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#DFFF3D] to-[#B8D622] flex items-center justify-center mb-5 warm-glow">
                                                <i className={`${c.icon.startsWith("fa-brands") ? c.icon : "fa-solid " + c.icon} text-[#0E1F16] text-[18px]`} />
                                            </div>
                                            <h3 className="font-display text-[#F5F0E8] text-[22px] tracking-tight leading-tight">{c.title}</h3>
                                            <p className="mt-2 text-[13.5px] text-[#A6BDB0] leading-[1.55]">{c.desc}</p>
                                            <div className="mt-4 flex flex-wrap gap-1.5">
                                                {c.tags.map((t) => <span key={t} className="mono text-[9.5px] px-2 py-1 rounded-full border border-[#1F3A2B] bg-[#0E1F16] text-[#A6BDB0]">{t}</span>)}
                                            </div>
                                            {c.partner && (
                                                <div className="mt-4 mono text-[9.5px] text-[#DFFF3D] flex items-center gap-1.5">
                                                    <i className="fa-solid fa-satellite-dish text-[9px]" />
                                                    <span>{c.partner}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="relative min-h-[200px] md:min-h-[280px] md:h-full min-w-0 overflow-hidden">
                                        <P />
                                    </div>
                                </div>
                            </motion.a>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
